<template>
  <div class="text-filter">
    <i-input
      ref="input"
      :placeholder="label"
      :value="value"
      @on-change="changeHandler"
      @on-focus="$event.target.select()"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  props: [
    'type',
    'field',
    'label'
  ],
  computed: {
    value () {
      return this.$store.state.filters[this.type][this.field]
    }
  },
  methods: {
    changeHandler: debounce(function (event) {
      const { value } = event.target

      this.$store.commit('CHANGE_FILTER', {
        type: this.type,
        field: this.field,
        value
      })
    }, 400)
  }
}
</script>

<style lang="less">
.text-filter {
  width: 100%;

  .ivu-input {
    width: 100%;
  }
}
</style>
